const BASE = "/api/agent/artifacts";

export async function listArtifacts({ sessionId, limit = 100 }) {
  const qs = new URLSearchParams({ session_id: String(sessionId), limit: String(limit) });
  const res = await fetch(`${BASE}?${qs}`, { credentials: "same-origin" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.message || data.error || `HTTP ${res.status}`);
    error.code = data.code;
    throw error;
  }
  return Array.isArray(data.artifacts) ? data.artifacts : [];
}

export async function updateArtifactLifecycle({ artifactId, action }) {
  const res = await fetch(`${BASE}/${encodeURIComponent(String(artifactId))}`, {
    method: "PATCH",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.message || data.error || `HTTP ${res.status}`);
    error.code = data.code;
    throw error;
  }
  return data;
}
